export const CHOOSING_YOUR_DOG: Record<ChoosingYourDogScreenNames, string> = {
	CYD_INTRO: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q8</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>INTRO</strong>
			</p>
		</div>
	`,

	Q8: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q9</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
		</div>
	`,

	Q9: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>All options</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q10</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
			<p>Selecting "Other" reveals text box</p>
		</div>
	`,

	Q10: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>General selling, pet selling or social media</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q10_1</td>
				</tr>
				<tr>
					<td>All other options</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q11</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
		</div>
	`,

	Q10_1: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q11</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
			<p>The title will include the option they chose on Q10 so they can further explain which</p>
		</div>
	`,

	Q11: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q11_1</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
			<p>"I can't remember" and "None of the above are exclusive"</p>
		</div>
	`,

	Q11_1: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>CHOOSING_YOUR_DOG</td>
					<td>Q11_2</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
			<p>"I can't remember" and "None of the above are exclusive"</p>
		</div>
	`,

	Q11_2: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>UNDERSTANDING_YOUR_DOG</td>
					<td>UYD_INTRO</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
		</div>
	`,
};
